import React from 'react';
import PropTypes from 'prop-types';
import CoreMap from '@bd/bdui-coremap';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import CommunityCard from '../../components/CommunityCard';
import { colors } from '../../styles';

const styles = css`
  .Communities_communitiesResults {
    position: relative;
    z-index: 1;
    @media (min-width: 992px) {
      display: flex;
    }
  }

  .Communities_communitiesList {
    position: relative;
    z-index: 1;
    height: auto;
    width: 100%;
    padding: 30px;
    margin-top: calc(-1 * calc(100vh - 115px));
    background-color: ${colors.color3Light};
    @media (max-width: 991px) {
      &.Communities_communitiesList--hide {
        display: none;
      }
    }
    @media (min-width: 992px) {
      width: 553px;
      padding: 20px;
      height: calc(100vh - 115px);
      overflow-y: scroll;
      margin-top: 0;
    }
  }
  .ShowMap_button {
    position: absolute;
    background-color: ${colors.color2};
  }
`;

const communityMap = css`
  position: relative;
  height: 250px;
  width: 100%;
  z-index: 0;

  @media (min-width: 992px) {
    width: auto;
    flex-grow: 1;
    height: 500px;
  }

  background-color: ${colors.color3};
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
  .leaflet-popup {
    margin-left: 18px;
  }
  .leaflet-popup-content {
    margin: 0;
  }
  .leaflet-popup-content-wrapper {
    border-radius: 0;
    .CommunityCard_wrapper {
      width: 100% !important;
      margin: 0;
    }
    .CommunityCard_inner  {
      padding: 0 15px;
    }
    .CommunityCard_media {
      display: none !important;
    }
    .CommunityCard_priceWrapper {
      display: none !important;
    }
    .CommunityCard_buttonWrapper {
      display: none !important;
    }
    .CommunityCard_content {
      padding: 15px;
    }
    .CommunityCard_content h4 {
      font-size: 18px;
    }
    .CommunityCard_content h5, .CommunityCard_content ul {
      display: none;
    }
  }
`;

function CommunityResults({ communities }) {
  return (
    <div className={styles}>
      <div className="Communities_communitiesResults">
        <CoreMap
          animate
          useFlyTo
          boundsOptions={{ animate: true, duration: 0.5 }}
          className={communityMap}
          markers={communities}
          boundarySize={5000}
          pin={{
            iconUrl: '/images/icon-map-pin-site.svg',
          }}
          popup={({ marker: community }) => (
            <CommunityCard community={community} />
          )}
        />
      </div>
    </div>
  );
}

CommunityResults.propTypes = {
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
};

CommunityResults.defaultProps = {
};

export default withData(
  {
    communities: true,
  },
  {
    required: {
      communities: true,
    },
  },
)(CommunityResults);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/CommunityMap.js